import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import HelpModuleMixin from '~/mixins/help/HelpModuleMixin';
let BaseView = class BaseView extends Mixins(HelpModuleMixin) {
};
BaseView = __decorate([
    Component
], BaseView);
export default BaseView;
